'use client';

import { CurrentTaskCta } from '@app/(darkHeader)/ai/_shared/_components/CurrentTaskCta/CurrentTaskCta';
import { useAiToolkitContext } from '@app/(darkHeader)/ai/_shared/_context/AiToolkitContext';
import { AI_TOOLKIT_CATEGORIES } from '@app/(darkHeader)/ai/_shared/_context/types';
import { type JSX, useCallback } from 'react';

import { AiWand } from '@videoblocks/design-system/icons';

export const CurrentVideoEditCta = (): JSX.Element | null => {
    const { submitStates, formStates, updateFormState, videoSearch, dispatchVideoEditSubmit } =
        useAiToolkitContext();
    const { status, originalThumbnailUrl, editedVideoUrl, lastCompletedEdit } =
        submitStates[AI_TOOLKIT_CATEGORIES.VIDEO_EDIT];
    const formState = formStates[AI_TOOLKIT_CATEGORIES.VIDEO_EDIT];

    const restoreLastCompleted = useCallback((): void => {
        dispatchVideoEditSubmit({ type: 'RESTORE_LAST_COMPLETED' });
        if (lastCompletedEdit && formState) {
            updateFormState(AI_TOOLKIT_CATEGORIES.VIDEO_EDIT, {
                ...formState,
                sourceVideo: lastCompletedEdit.originalVideoUrl,
                contentId: lastCompletedEdit.contentId,
                startTime: lastCompletedEdit.startTime ?? 0,
                duration: lastCompletedEdit.duration ?? formState.duration,
            });
        }
        videoSearch.setShowSearch(false);
    }, [dispatchVideoEditSubmit, videoSearch, lastCompletedEdit, updateFormState, formState]);

    const placeholderIcon = <AiWand width={16} height={16} className="dark:[&_path]:fill-neutral-dark-1000" />;

    if (status === 'selection') {
        if (!lastCompletedEdit) return null;
        return (
            <CurrentTaskCta
                title="Current edit"
                status="success"
                thumbnailUrl={lastCompletedEdit.originalThumbnailUrl || undefined}
                videoUrl={lastCompletedEdit.editedVideoUrl || undefined}
                placeholderIcon={placeholderIcon}
                onClick={restoreLastCompleted}
                dataTestId="current-video-edit-cta"
            />
        );
    }

    return (
        <CurrentTaskCta
            title="Current edit"
            status={status}
            thumbnailUrl={originalThumbnailUrl || undefined}
            videoUrl={editedVideoUrl || undefined}
            placeholderIcon={placeholderIcon}
            onClick={() => videoSearch.setShowSearch(false)}
            dataTestId="current-video-edit-cta"
        />
    );
};
